// Admin Login Page
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAdminAuth } from '../utils/authContext';
import { useAdminTranslation } from '../utils/i18nContext';
import { toast } from 'sonner';
import { Shield, LogIn } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const { t } = useAdminTranslation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: 'office@neuro-mesh.io',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await login(formData.email, formData.password);
      console.log('Login successful');
      toast.success('Login successful!');
      
      // Wait for auth state to update, then redirect
      setTimeout(() => {
        navigate('/neuro-admin-access/dashboard');
      }, 1000);
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-[#0A0A0A] border-cyan-500/20">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Shield className="w-16 h-16 text-cyan-400" />
          </div>
          <CardTitle className="text-2xl text-white">{t('admin_login')}</CardTitle>
          <p className="text-sm text-gray-400 mt-2">NeuroMesh Admin Panel</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm text-gray-300 block mb-2">{t('email')}</label>
              <Input
                type="email"
                value={formData.email}
                disabled
                className="bg-[#1A1A1A] border-white/10 text-gray-400"
              />
            </div>

            <div>
              <label className="text-sm text-gray-300 block mb-2">{t('password')}</label>
              <Input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="bg-[#1A1A1A] border-white/10 text-white"
                required
                autoFocus
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-cyan-500 to-purple-500 hover:from-cyan-600 hover:to-purple-600 text-white font-semibold"
            >
              <LogIn className="w-4 h-4 mr-2" />
              {loading ? t('loading') : t('login')}
            </Button>

            <div className="text-center mt-4">
              <p className="text-sm text-gray-400">
                Don't have an account?{' '}
                <Link to="/neuro-admin-access/setup" className="text-cyan-400 hover:text-cyan-300">
                  Create Account
                </Link>
              </p>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
